import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Div = styled.div.withConfig({ componentId: 'sc-8qhtlx-0' })`
  font-family: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fontFamily' does not exist on type 'Them... Remove this comment to see the full error message
    props.fontFamily};
  text-align: center;
`;

type Props = {
  err?: string;
  ff?: string;
  location?: any;
};

export default class NumberInLine extends PureComponent<Props> {
  render = () => (
    // @ts-expect-error ts-migrate(2769) FIXME: Property 'fontFamily' does not exist on type 'Intr... Remove this comment to see the full error message
    <Div data-testid="Number In Line" fontFamily={this.props.ff}>
      {this.props.err || this.props.location.waitListCount}
    </Div>
  );
}
